import { useEffect, useState } from "react";
import { AlertTriangle, ChevronDown } from "lucide-react";
import { api } from "@/lib/api";

const M = { day: "G", night: "S" };

export const CoveragePanel = () => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);
  useEffect(() => { api.get("/admin/catalog/coverage").then((r) => setData(r.data)).catch(() => setData({ rows: [], gaps: [], profiles: [] })); }, []);
  if (!data) return null;

  return (
    <div className="bg-white border border-[#E2DACF] mb-6" data-testid="catalog-coverage">
      <button className="w-full flex items-center justify-between px-6 py-4 text-left" onClick={() => setOpen((o) => !o)} data-testid="catalog-coverage-toggle">
        <div>
          <p className="font-serif text-xl">Copertura del catalogo</p>
          <p className="text-xs text-[#8C8275] mt-1">Prodotti attivi e disponibili per ogni step e tipo di pelle (G = giorno, S = sera). Le caselle in rosso sono step che una cliente con quel tipo di pelle non riceverà: aggiungi su Shopify il tag <code className="bg-[#FAF8F5] px-1">skin:…</code> ai prodotti giusti o importane di nuovi.</p>
        </div>
        <span className="flex items-center gap-3 shrink-0 ml-4">
          {data.gaps.length > 0 && <span className="inline-flex items-center gap-1 text-xs text-[#9B3B2E] bg-[#F9E9E6] px-2 py-1 rounded-full" data-testid="catalog-coverage-gaps-count"><AlertTriangle size={12} /> {data.gaps.length} mancanze</span>}
          <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </span>
      </button>
      {open && (
        <div className="px-6 pb-6 overflow-x-auto">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-[#595652] mb-4" data-testid="catalog-coverage-legend">
            <span className="text-[#8C8275]">Ogni casella = quanti prodotti attivi e disponibili il motore può proporre. <strong className="font-medium">G</strong> = routine del giorno, <strong className="font-medium">S</strong> = routine della sera.</span>
            <span className="inline-flex items-center gap-1.5"><span className="px-2 py-0.5 rounded-full bg-[#E9F3EA] text-[#2F6B3A]">G 3+</span> coperto: c'è scelta (principale + alternative)</span>
            <span className="inline-flex items-center gap-1.5"><span className="px-2 py-0.5 rounded-full bg-[#FBF3E3] text-[#8C6F3E]">G 1–2</span> scarso: 1 o 2 prodotti, nessuna o poche alternative</span>
            <span className="inline-flex items-center gap-1.5"><span className="px-2 py-0.5 rounded-full bg-[#F9E9E6] text-[#9B3B2E]">G 0</span> mancante: la cliente non riceve questo step</span>
            <span className="text-[#8C8275]">Casella assente = lo step non è previsto in quel momento (es. maschera solo la sera).</span>
          </div>
          <table className="w-full text-sm" data-testid="catalog-coverage-table">
            <thead>
              <tr>
                <th className="text-left font-medium text-[#8C8275] text-xs pb-2 pr-4">Step</th>
                {data.profiles.map((p) => <th key={p.key} className="text-left font-medium text-[#8C8275] text-xs pb-2 pr-4">{p.name}<br /><code className="text-[10px] text-[#C2B8A8]">{p.tag}</code></th>)}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((r) => (
                <tr key={r.step} className="border-t border-[#F2ECE4]" data-testid={`coverage-row-${r.step}`}>
                  <td className="py-2.5 pr-4 text-[#1A1A18]">{r.step_name}</td>
                  {r.cells.map((c) => (
                    <td key={c.skin} className="py-2.5 pr-4">
                      <span className="inline-flex gap-1.5">
                        {r.moments.map((m) => {
                          const n = c.counts[m] || 0;
                          return <span key={m} data-testid={`coverage-${r.step}-${c.skin}-${m}`} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs tabular-nums ${n === 0 ? "bg-[#F9E9E6] text-[#9B3B2E]" : n < 3 ? "bg-[#FBF3E3] text-[#8C6F3E]" : "bg-[#E9F3EA] text-[#2F6B3A]"}`}>{M[m]} {n}</span>;
                        })}
                      </span>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          {data.gaps.length > 0 && (
            <div className="mt-5 text-xs text-[#595652]" data-testid="catalog-coverage-gaps">
              <p className="font-medium text-[#1A1A18] mb-2">Da coprire su Shopify</p>
              <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-1">
                {data.gaps.map((g) => <li key={`${g.step_key}-${g.tag}`}>• <strong className="font-medium">{g.step}</strong> per {g.skin.toLowerCase()} ({g.moments.map((m) => (m === "day" ? "giorno" : "sera")).join(", ")}) → tagga un prodotto <code className="bg-[#FAF8F5] px-1">step:{g.step_key}</code> <code className="bg-[#FAF8F5] px-1">{g.tag}</code></li>)}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
